<div class="not-found-container">
    <div class="response-code-big">404</div>
    <h2 class="title">Oops! Page Not Found</h2>
    <p class="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean fermentum dui quis ipsum tincidunt, sed iaculis sem posuere. </p>
</div>
